import { ReactNode } from "react"

interface Props {
    children: (() => ReactNode) | ReactNode
}

export function HeadingContainer({ children }: Props) {
    return (
        <div className="booking-heading__container">
            <div className="redesign-container">
                <div className="booking-heading">
                    <div className="booking-heading__avatar-container">
                        {typeof children === "function" ? children() : children}
                    </div>
                </div>
            </div>
        </div>
    )
}
